"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsePriceOffering = exports.parseAccessoryResponse = void 0;
var _constants = require("../../utils/constants");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getProductSpecCharacteristicValue = function getProductSpecCharacteristicValue(advancedPayment, name) {
  return advancedPayment.prodSpecCharValueUse.find(function (el) {
    return el.name === name;
  }).productSpecCharacteristicValue[0];
};
var parsePriceOffering = function parsePriceOffering(variant) {
  var advancedPayment = variant.productOfferingPrice.find(function (el) {
    return el.priceType === _constants.PRICE_TYPES.ADVANCE_PAYMENT;
  });
  var totalPrice = advancedPayment.price;
  var maxUpfront = getProductSpecCharacteristicValue(advancedPayment, 'maxUpFront');
  var minUpfront = getProductSpecCharacteristicValue(advancedPayment, 'minUpFront');
  var upfrontIncrementStep = getProductSpecCharacteristicValue(advancedPayment, 'paymentStep');
  var maxTerm = getProductSpecCharacteristicValue(advancedPayment, 'maxTerm');
  var minTerm = getProductSpecCharacteristicValue(advancedPayment, 'minTerm');
  var termIncrementStep = getProductSpecCharacteristicValue(advancedPayment, 'termStep');
  return {
    totalPrice: totalPrice,
    maxUpfront: maxUpfront,
    minUpfront: minUpfront,
    upfrontIncrementStep: upfrontIncrementStep,
    maxTerm: maxTerm,
    minTerm: minTerm,
    termIncrementStep: termIncrementStep
  };
};
exports.parsePriceOffering = parsePriceOffering;
var getCharacteristicValue = function getCharacteristicValue(offering, characteristicName) {
  var _offering$prodSpecCha;
  var characteristic = offering === null || offering === void 0 ? void 0 : (_offering$prodSpecCha = offering.prodSpecCharValueUse) === null || _offering$prodSpecCha === void 0 ? void 0 : _offering$prodSpecCha.find(function (char) {
    return char.name === characteristicName;
  });
  if (characteristic) {
    var _characteristic$produ, _characteristic$produ2;
    var value = (_characteristic$produ = characteristic.productSpecCharacteristicValue[0]) === null || _characteristic$produ === void 0 ? void 0 : _characteristic$produ.value;
    var unitOfMeasure = (_characteristic$produ2 = characteristic.productSpecCharacteristicValue[0]) === null || _characteristic$produ2 === void 0 ? void 0 : _characteristic$produ2.unitOfMeasure;
    return unitOfMeasure ? "".concat(value, "|").concat(unitOfMeasure) : value;
  }
};
var parseAccessoryResponse = function parseAccessoryResponse(variantsData) {
  var selectionTree = {
    colors: {},
    sizes: {}
  };
  var variants = variantsData.map(function (variant) {
    var newVariant = _objectSpread({}, variant);
    newVariant.priceOffering = parsePriceOffering(variant);
    newVariant.color = getCharacteristicValue(variant, 'color');
    newVariant.size = getCharacteristicValue(variant, 'Screen Size');
    newVariant.media = variant.attachment;
    if (selectionTree.colors[newVariant.color]) {
      selectionTree.colors[newVariant.color].push(newVariant.size);
    } else {
      selectionTree.colors[newVariant.color] = [newVariant.size];
    }
    if (selectionTree.sizes[newVariant.size]) {
      selectionTree.sizes[newVariant.size].push(newVariant.color);
    } else {
      selectionTree.sizes[newVariant.size] = [newVariant.color];
    }
    return newVariant;
  });
  return {
    variants: variants,
    selectionTree: selectionTree
  };
};
exports.parseAccessoryResponse = parseAccessoryResponse;